/**
 * Contract Routes
 *
 * Routes for contracts and document server.
 */

import { createPermissionBeforeLoad } from '@bb/session-manager';
import { createRoute } from '@tanstack/react-router';
import React from 'react';
import * as groups from '../../groups.config';
import { authLayoutRoute } from '../rootRoute';

// Lazy load pages
const Contracts = React.lazy(() => import('../../pages/Contracts/Contracts'));
const DocServer = React.lazy(() => import('../../pages/DocServer/DocServer'));
const DocServerReadOnly = React.lazy(
  () => import('../../pages/DocServerReadOnly/DocServerReadOnly')
);

const contractsPermission = createPermissionBeforeLoad({
  permissions: [groups.CONTRACTS_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

/**
 * Contracts list page
 */
export const contractsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/contracts',
  beforeLoad: contractsPermission,
  component: Contracts,
});

/**
 * Document server - editable
 */
export const docServerRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/oo',
  beforeLoad: contractsPermission,
  component: DocServer,
});

/**
 * Document server - read only
 */
export const docServerReadOnlyRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/readonly',
  beforeLoad: contractsPermission,
  component: DocServerReadOnly,
});

export const contractRoutes = [contractsRoute, docServerRoute, docServerReadOnlyRoute];
